import React from 'react';
import styled from 'styled-components/macro';

import { ReactComponent as SearchIcon } from 'icons/icon-search.svg';
import modularScale from 'styles/helpers/modular-scale';

const Form = styled('form')<any>`
  margin: ${({ theme }): string =>
    `${theme.spacing.xsmall} 0 ${theme.spacing.small}`};
  border-bottom: 2px solid white;
  display: flex;
  justify-content: space-between;

  @media screen and (min-width: 44em) {
    margin: ${({ theme }): string => theme.spacing.xlarge} 0;
  }
`;

const Input = styled('input')<any>`
  appearance: none;
  width: 100%;
  background: transparent;
  border: none;
  border-radius: 0;
  box-shadow: none;
  outline: none;
  color: white;
  font-size: ${modularScale(2)};
  font-family: inherit;
  overflow: auto;

  &::placeholder {
    color: rgba(255, 255, 255, 0.5);
    opacity: 1;
  }

  ::-ms-clear {
    display: none;
  }

  @media screen and (min-width: 43em) {
    font-size: ${modularScale(4)};
  }
  @media screen and (min-width: 80em) {
    font-size: ${modularScale(6)};
  }
`;

const SearchIconWrapper = styled('div')`
  display: flex;
  padding: ${({ theme }): string => theme.spacing.small};

  @media screen and (min-width: 43em) {
    padding: ${({ theme }): string => theme.spacing.medium};
  }

  svg {
    color: white;
    opacity: 0.75;
    width: ${({ theme }): string => theme.spacing.large};
    height: ${({ theme }): string => theme.spacing.large};

    @media screen and (min-width: 43em) {
      width: ${({ theme }): string => theme.spacing.xlarge};
      height: ${({ theme }): string => theme.spacing.xlarge};
    }
  }

  @media screen and (min-width: 80em) {
    padding: ${({ theme }): string => theme.spacing.large};
  }
`;

interface IInputFormProps {
  /** The default or user selected type e.g "track" */
  entityType: string;
  /** Boolean to represent an invalid search request */
  invalid: boolean;
  /** Callback method called while the user is typing */
  handleChange: (event?: any) => any;
  /** Callback method invoked when focusing on the input form */
  handleFocus: (event?: any) => any;
  /** HandleSubmit is called when the user presses search or enter */
  handleSubmit: (event?: any) => any;
  /** The input might have a value already if the URL contains a query */
  value: string;
  /** Do you want the input to automatically have focus, ie. should the user be able to start typing immediately? */
  enableAutoFocus?: boolean;
}

/**
 * InputForm contains the search field and the necessary callbacks
 */
const InputForm = ({
  entityType,
  invalid,
  handleChange,
  value,
  enableAutoFocus = true,
  handleSubmit,
  handleFocus,
}: IInputFormProps): JSX.Element => (
  <Form
    role="search"
    onSubmit={handleSubmit}
    action=""
    data-pw="search-input-form"
  >
    <SearchIconWrapper>
      <SearchIcon />
    </SearchIconWrapper>
    <Input
      type="search"
      value={value}
      onFocus={handleFocus}
      placeholder={`Search ${entityType === 'all' ? 'Opus' : `${entityType}s`}`}
      autoFocus={enableAutoFocus}
      required
      aria-label={`Search ${entityType === 'all' ? 'Opus' : `${entityType}s`}`}
      aria-required="true"
      aria-invalid={invalid}
      onChange={handleChange}
    />
  </Form>
);

export default InputForm;
